(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 6086:
/***/ (function(module) {

"use strict";

var assign = Object.assign.bind(Object);
module.exports = assign;
module.exports["default"] = module.exports;

//# sourceMappingURL=object-assign.js.map

/***/ }),

/***/ 8581:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(3326);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4401:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/doodle.8b7351ed.png","height":1024,"width":1024,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAASFBMVEVMaXFRVVo3X3FicowAGCNfZ3t0bn51doErU2M4WG4VTlmMiJBQaYCYd4F7dXoXNT/bqq1bXWRrY1/AqKvUwsfDmZadhYeflJ4+pW4sAAAAFXRSTlMAU8zVCfr+Hzn0FPrE/ixR/OaC/PmdUM1iAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAPElEQVQImWNgYGDgYmEAA0ZWZnYQzccmJsoDYgiJiQiLc4BkRAV4uUEMFkE2ViawYn5OTpAAAwMDO0gTADXjAXcNRspHAAAAAElFTkSuQmCC"});

/***/ }),

/***/ 4820:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ NowPlaying; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7320);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(821);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7985);
/* harmony import */ var _io_components_ExternalLink__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3778);
/* harmony import */ var _io_lib_fetcher__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6110);





var buildTwitterIntentLink = function(intentTranslatedText, songTitle) {
    var intentTwitterLink = 'https://twitter.com/intent/tweet?screen_name=ivolivares&text=';
    if (songTitle) {
        return intentTwitterLink + intentTranslatedText.replace(/<song-name>/g, songTitle);
    }
    return intentTwitterLink + intentTranslatedText;
};
function NowPlaying() {
    var data = (0,swr__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)('/api/now-playing', _io_lib_fetcher__WEBPACK_IMPORTED_MODULE_4__/* .fetcher */ ._).data;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)('common').t;
    var ref;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("span", {
        children: !data ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("span", {
            children: t('spotify-loading')
        }) : (data === null || data === void 0 ? void 0 : data.isPlaying) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .Fragment */ .HY, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("span", {
                    className: "mr-1",
                    children: t('spotify-playing-start')
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_io_components_ExternalLink__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    classNames: "text-gray-800 dark:text-gray-200 font-medium max-w-max",
                    href: data.songUrl,
                    children: "".concat(data.title, " ").concat(t('spotify-playing-by'), " ").concat((ref = data === null || data === void 0 ? void 0 : data.artist) !== null && ref !== void 0 ? ref : 'Spotify')
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("span", {
                    className: "mx-1",
                    children: t('spotify-playing-where')
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_io_components_ExternalLink__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    classNames: "font-medium max-w-max",
                    href: buildTwitterIntentLink(t('spotify-playing-twitter-intent'), data.title),
                    children: t('spotify-playing-cta')
                })
            ]
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .Fragment */ .HY, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("span", {
                    className: "mr-1",
                    children: t('spotify-not-playing')
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_io_components_ExternalLink__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    classNames: "font-medium max-w-max",
                    href: buildTwitterIntentLink(t('spotify-not-playing-twitter-intent')),
                    children: t('spotify-not-playing-cta')
                })
            ]
        })
    }));
};


/***/ }),

/***/ 6948:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7320);
/* harmony import */ var _io_components_Meta__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8549);
/* harmony import */ var _io_components_Header__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7673);
/* harmony import */ var _io_components_Footer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5315);




function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var MainLayout = function(_param) {
    var children = _param.children, props = _objectWithoutProperties(_param, [
        "children"
    ]);
    var tagline = props.tagline;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .Fragment */ .HY, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_io_components_Meta__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, _objectSpread({}, props)),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_io_components_Header__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("main", {
                id: "main-content",
                className: "flex flex-col justify-center w-full mx-auto max-w-5xl pb-10 px-5 sm:px-10 mb-4",
                children: [
                    tagline && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("h1", {
                        className: "pt-10 xs:pt-5 sm:pt-2 mb-8 title-font text-5xl lg:text-4xl xl:text-5xl font-bold tracking-tighter text-left text-gray-800 dark:text-gray-100",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("span", {
                            className: "decoration-clone bg-clip-text text-transparent bg-gradient-to-r from-primary-300 to-green-500",
                            children: tagline
                        })
                    }),
                    children
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_io_components_Footer__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {})
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (MainLayout);


/***/ }),

/***/ 6110:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ fetcher; }
/* harmony export */ });
/* unused harmony export getToken */
/* harmony import */ var _vercel_path1_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4051);
/* harmony import */ var _vercel_path1_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path1_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
/**
 * Request Token to fetch any endpoint resource.
 * Yes, this is not the best security but is a mini-layer to avoid open endpoints.
 * 
 * @param {String} endpoint Endpoint request
 * @returns Response JSON with auth_token
 */ function getToken(endpoint) {
    return _getToken.apply(this, arguments);
}
function _getToken() {
    _getToken = _asyncToGenerator(_vercel_path1_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(endpoint) {
        var token_query;
        return _vercel_path1_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return fetch("/api/token?for=".concat(endpoint));
                case 2:
                    token_query = _ctx.sent;
                    return _ctx.abrupt("return", token_query.json());
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _getToken.apply(this, arguments);
}
function fetcher(input, init) {
    return _fetcher.apply(this, arguments);
}
function _fetcher() {
    _fetcher = _asyncToGenerator(_vercel_path1_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(input, init) {
        var auth_token, res;
        return _vercel_path1_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return getToken(input);
                case 2:
                    auth_token = _ctx.sent.auth_token;
                    _ctx.next = 5;
                    return fetch(input, _objectSpread({}, init, {
                        headers: {
                            Authorization: "Bearer ".concat(auth_token)
                        }
                    }));
                case 5:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res.json());
                case 7:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _fetcher.apply(this, arguments);
}


/***/ }),

/***/ 638:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
__webpack_unused_export__ = ({
    value: true
});
__webpack_unused_export__ = noSSR;
exports["default"] = dynamic;
var _react = _interopRequireDefault(__webpack_require__(1720));
var _loadable = _interopRequireDefault(__webpack_require__(4302));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var isServerSide = "object" === 'undefined';
function noSSR(LoadableInitializer, loadableOptions) {
    // Removing webpack and modules means react-loadable won't try preloading
    delete loadableOptions.webpack;
    delete loadableOptions.modules;
    // This check is necessary to prevent react-loadable from initializing on the server
    if (!isServerSide) {
        return LoadableInitializer(loadableOptions);
    }
    var Loading = loadableOptions.loading;
    // This will only be rendered on the server side
    return function() {
        /*#__PURE__*/ return _react.default.createElement(Loading, {
            error: null,
            isLoading: true,
            pastDelay: false,
            timedOut: false
        });
    };
}
function dynamic(dynamicOptions, options) {
    var loadableFn = _loadable.default;
    var loadableOptions = {
        // A loading component is not required, so we default it
        loading: function(param) {
            var error = param.error, isLoading = param.isLoading, pastDelay = param.pastDelay;
            if (!pastDelay) return null;
            if (false) {}
            return null;
        }
    };
    // Support for direct import(), eg: dynamic(import('../hello-world'))
    // Note that this is only kept for the edge case where someone is passing in a promise as first argument
    // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
    // To make sure we don't execute the import without rendering first
    if (_instanceof(dynamicOptions, Promise)) {
        loadableOptions.loader = function() {
            return dynamicOptions;
        };
    // Support for having import as a function, eg: dynamic(() => import('../hello-world'))
    } else if (typeof dynamicOptions === 'function') {
        loadableOptions.loader = dynamicOptions;
    // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
    } else if (typeof dynamicOptions === 'object') {
        loadableOptions = _objectSpread({}, loadableOptions, dynamicOptions);
    }
    // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})
    loadableOptions = _objectSpread({}, loadableOptions, options);
    var suspenseOptions = loadableOptions;
    if (true) {
        // Error if react root is not enabled and `suspense` option is set to true
        if ( true && suspenseOptions.suspense) {
            // TODO: add error doc when this feature is stable
            throw new Error("Invalid suspense option usage in next/dynamic. Read more: https://nextjs.org/docs/messages/invalid-dynamic-suspense");
        }
    }
    if (suspenseOptions.suspense) {
        return loadableFn(suspenseOptions);
    }
    // coming from build/babel/plugins/react-loadable-plugin.js
    if (loadableOptions.loadableGenerated) {
        loadableOptions = _objectSpread({}, loadableOptions, loadableOptions.loadableGenerated);
        delete loadableOptions.loadableGenerated;
    }
    // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false})
    if (typeof loadableOptions.ssr === 'boolean') {
        if (!loadableOptions.ssr) {
            delete loadableOptions.ssr;
            return noSSR(loadableFn, loadableOptions);
        }
        delete loadableOptions.ssr;
    }
    return loadableFn(loadableOptions);
} //# sourceMappingURL=dynamic.js.map


/***/ }),

/***/ 6319:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.LoadableContext = void 0;
var _react = _interopRequireDefault(__webpack_require__(1720));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var LoadableContext = _react.default.createContext(null);
exports.LoadableContext = LoadableContext;
if (false) {} //# sourceMappingURL=loadable-context.js.map


/***/ }),

/***/ 4302:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _react = _interopRequireDefault(__webpack_require__(1720));
var _useSubscription = __webpack_require__(7161);
var _loadableContext = __webpack_require__(6319);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var ALL_INITIALIZERS = [];
var READY_INITIALIZERS = [];
var initialized = false;
function load(loader) {
    var promise = loader();
    var state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then(function(loaded) {
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch(function(err) {
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function createLoadableComponent(loadFn, options) {
    var init = function init() {
        if (!subscription) {
            var sub = new LoadableSubscription(loadFn, opts);
            subscription = {
                getCurrentValue: sub.getCurrentValue.bind(sub),
                subscribe: sub.subscribe.bind(sub),
                retry: sub.retry.bind(sub),
                promise: sub.promise.bind(sub)
            };
        }
        return subscription.promise();
    };
    var LoadableImpl = function LoadableImpl(props, ref) {
        init();
        var context = _react.default.useContext(_loadableContext.LoadableContext);
        var state = (0, _useSubscription).useSubscription(subscription);
        _react.default.useImperativeHandle(ref, function() {
            return {
                retry: subscription.retry
            };
        }, []);
        if (context && Array.isArray(opts.modules)) {
            opts.modules.forEach(function(moduleName) {
                context(moduleName);
            });
        }
        return _react.default.useMemo(function() {
            if (state.loading || state.error) {
                return _react.default.createElement(opts.loading, {
                    isLoading: state.loading,
                    pastDelay: state.pastDelay,
                    timedOut: state.timedOut,
                    error: state.error,
                    retry: subscription.retry
                });
            } else if (state.loaded) {
                return _react.default.createElement(resolve(state.loaded), props);
            } else {
                return null;
            }
        }, [
            props,
            state
        ]);
    };
    var LazyImpl = function LazyImpl(props, ref) {
        return _react.default.createElement(opts.lazy, _objectSpread({}, props, {
            ref: ref
        }));
    };
    var opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        webpack: null,
        modules: null,
        suspense: false
    }, options);
    if (opts.suspense) {
        opts.lazy = _react.default.lazy(opts.loader);
    }
    var subscription = null;
    // Server only
    if (false) {}
    // Client only
    if (!initialized && "object" !== 'undefined' && !opts.suspense) {
        // require.resolveWeak check is needed for environments that don't have it available like Jest
        var moduleIds = opts.webpack && "function" === 'function' ? opts.webpack() : opts.modules;
        if (moduleIds) {
            READY_INITIALIZERS.push(function(ids) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = moduleIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var moduleId = _step.value;
                        if (ids.indexOf(moduleId) !== -1) {
                            return init();
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            });
        }
    }
    var LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;
    LoadableComponent.preload = function() {
        return !opts.suspense && init();
    };
    LoadableComponent.displayName = 'LoadableComponent';
    return _react.default.forwardRef(LoadableComponent);
}
var LoadableSubscription = /*#__PURE__*/ function() {
    function LoadableSubscription(loadFn, opts) {
        _classCallCheck(this, LoadableSubscription);
        this._loadFn = loadFn;
        this._opts = opts;
        this._callbacks = new Set();
        this._delay = null;
        this._timeout = null;
        this.retry();
    }
    _createClass(LoadableSubscription, [
        {
            key: "promise",
            value: function promise() {
                return this._res.promise;
            }
        },
        {
            key: "retry",
            value: function retry() {
                var _this = this;
                this._clearTimeouts();
                this._res = this._loadFn(this._opts.loader);
                this._state = {
                    pastDelay: false,
                    timedOut: false
                };
                var ref = this, res = ref._res, opts = ref._opts;
                if (res.loading) {
                    if (typeof opts.delay === 'number') {
                        if (opts.delay === 0) {
                            this._state.pastDelay = true;
                        } else {
                            var _this1 = this;
                            this._delay = setTimeout(function() {
                                _this1._update({
                                    pastDelay: true
                                });
                            }, opts.delay);
                        }
                    }
                    if (typeof opts.timeout === 'number') {
                        var _this2 = this;
                        this._timeout = setTimeout(function() {
                            _this2._update({
                                timedOut: true
                            });
                        }, opts.timeout);
                    }
                }
                this._res.promise.then(function() {
                    _this._update({});
                    _this._clearTimeouts();
                }).catch(function(_err) {
                    _this._update({});
                    _this._clearTimeouts();
                });
                this._update({});
            }
        },
        {
            key: "_update",
            value: function _update(partial) {
                this._state = _objectSpread({}, this._state, {
                    error: this._res.error,
                    loaded: this._res.loaded,
                    loading: this._res.loading
                }, partial);
                this._callbacks.forEach(function(callback) {
                    return callback();
                });
            }
        },
        {
            key: "_clearTimeouts",
            value: function _clearTimeouts() {
                clearTimeout(this._delay);
                clearTimeout(this._timeout);
            }
        },
        {
            key: "getCurrentValue",
            value: function getCurrentValue() {
                return this._state;
            }
        },
        {
            key: "subscribe",
            value: function subscribe(callback) {
                var _this = this;
                this._callbacks.add(callback);
                return function() {
                    _this._callbacks.delete(callback);
                };
            }
        }
    ]);
    return LoadableSubscription;
}();
function Loadable(opts) {
    return createLoadableComponent(load, opts);
}
function flushInitializers(initializers, ids) {
    var promises = [];
    while(initializers.length){
        var init = initializers.pop();
        promises.push(init(ids));
    }
    return Promise.all(promises).then(function() {
        if (initializers.length) {
            return flushInitializers(initializers, ids);
        }
    });
}
Loadable.preloadAll = function() {
    return new Promise(function(resolveInitializers, reject) {
        flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
    });
};
Loadable.preloadReady = function() {
    var ids = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return new Promise(function(resolvePreload) {
        var res = function() {
            initialized = true;
            return resolvePreload();
        };
        // We always will resolve, errors should be handled within loading UIs.
        flushInitializers(READY_INITIALIZERS, ids).then(res, res);
    });
};
if (true) {
    window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}
var _default = Loadable;
exports["default"] = _default; //# sourceMappingURL=loadable.js.map


/***/ }),

/***/ 3326:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/preact/compat/jsx-runtime.mjs
var jsx_runtime = __webpack_require__(7320);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 28 modules
var esm = __webpack_require__(7985);
// EXTERNAL MODULE: ./node_modules/preact/compat/dist/compat.module.js + 1 modules
var compat_module = __webpack_require__(1720);
;// CONCATENATED MODULE: ./lib/useIsFontReady.js
/**
 * A custom hook to detect when custom fonts have finished loading
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Document/fonts
 * 
 * Originally inspired by Delba Oliveira hook
 * @see https://github.com/delbaoliveira/website/blob/main/lib/useIsFontReady.ts
 */ 
function useIsFontReady() {
    var ref = (0,compat_module.useState)(false), isReady = ref[0], setIsReady = ref[1];
    (0,compat_module.useEffect)(function() {
        document.fonts.ready.then(function() {
            setIsReady(true);
        });
    }, []);
    return isReady;
}

// EXTERNAL MODULE: ./layouts/MainLayout.js
var MainLayout = __webpack_require__(6948);
// EXTERNAL MODULE: ./node_modules/regexify-string/index.js
var regexify_string = __webpack_require__(8817);
// EXTERNAL MODULE: ./components/ExternalLink.js
var ExternalLink = __webpack_require__(3778);
;// CONCATENATED MODULE: ./components/TransWithLinks.js

/* eslint-disable react/display-name */ /**
 * @description This is a temporal help to translate with special links.
 * TODO: Change and improve to have the i18n texts always into locales.json files.
 */ 


var WMLink = function() {
    return(/*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ExternalLink/* default */.Z, {
        href: "https://www.warnermedia.com",
        classNames: "font-medium",
        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
            children: "WarnerMedia"
        })
    }));
};
var GLBLink = function() {
    return(/*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ExternalLink/* default */.Z, {
        href: "https://www.globant.com",
        classNames: "font-medium",
        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
            children: "Globant"
        })
    }));
};
var LinkToTalks = function(param) {
    var lang = param.lang;
    var text = {
        es: 'hablando en meetups y conferencias',
        en: 'speaking at meetups and conference events'
    };
    return(/*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(next_link["default"], {
        href: "/talks",
        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("a", {
            className: "font-medium",
            children: text[lang]
        })
    }));
};
var TransWithLinks = function(param) {
    var i18nText = param.i18nText;
    var links = {
        '<wm />': function() {
            /*#__PURE__*/ return (0,jsx_runtime/* jsx */.tZ)(WMLink, {}, "0");
        },
        '<glb />': function() {
            /*#__PURE__*/ return (0,jsx_runtime/* jsx */.tZ)(GLBLink, {}, "1");
        },
        '<link-talks-en />': function() {
            /*#__PURE__*/ return (0,jsx_runtime/* jsx */.tZ)(LinkToTalks, {
                lang: "en"
            }, "2");
        },
        '<link-talks-es />': function() {
            /*#__PURE__*/ return (0,jsx_runtime/* jsx */.tZ)(LinkToTalks, {
                lang: "es"
            }, "3");
        }
    };
    return (0,regexify_string/* default */.Z)({
        pattern: /(<wm \/>|<glb \/>|<link-talks-(en|es) \/>)/g,
        decorator: function(match, _) {
            return links[match]();
        },
        input: i18nText
    });
};
/* harmony default export */ var components_TransWithLinks = (TransWithLinks);

// EXTERNAL MODULE: ./public/static/images/doodle.png
var doodle = __webpack_require__(4401);
;// CONCATENATED MODULE: ./components/MyDoodle/MyDoodleLoader.js



var MyDoodleLoader = function() {
    return(/*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
        id: "mydoodleanimated--loader",
        className: "flex justify-center items-center bg-gray-100 dark:bg-gray-600 rounded-full animate-pulse",
        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(next_image["default"], {
            src: doodle/* default */.Z,
            alt: "My Doodle by Maetschl Cartoons",
            priority: true,
            placeholder: "blur",
            layout: "intrinsic",
            className: "opacity-0",
            width: "512",
            height: "512"
        })
    }));
};
/* harmony default export */ var MyDoodle_MyDoodleLoader = (MyDoodleLoader);

// EXTERNAL MODULE: ./components/NowPlaying.js
var NowPlaying = __webpack_require__(4820);
;// CONCATENATED MODULE: ./pages/index.js











var Home = function() {
    var t = (0,esm/* useTranslation */.$G)('home').t;
    var isFontReady = useIsFontReady();
    var MyDoodleAnimated = (0,dynamic["default"])(function() {
        return __webpack_require__.e(/* import() */ 898).then(__webpack_require__.bind(__webpack_require__, 9898));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(9898)
                ];
            }
        },
        loading: function() {
            /*#__PURE__*/ return (0,jsx_runtime/* jsx */.tZ)(MyDoodle_MyDoodleLoader, {});
        },
        ssr: false
    });
    return(/*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(MainLayout/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("section", {
            className: "flex flex-col pt-4 md:pt-16 mx-auto items-top lg:items-center md:flex-row",
            children: [
                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                    className: "m-auto mb-5 md:my-0 w-1/2 md:w-full xl:w-5/6 motion-safe:hidden justify-center flex-col motion-reduce:flex",
                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(next_image["default"], {
                        src: doodle/* default */.Z,
                        alt: "My Doodle by Maetschl Cartoons",
                        priority: true,
                        placeholder: "blur",
                        layout: "intrinsic",
                        className: "dark:bg-gray-300 rounded-full",
                        width: "512",
                        height: "512"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                    className: "m-auto mb-5 md:my-0 w-1/2 md:w-full xl:w-5/6 motion-safe:flex justify-center flex-col motion-reduce:hidden",
                    children: isFontReady && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(MyDoodleAnimated, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                    className: "flex flex-col items-start text-left xl:flex-grow headlines",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("h1", {
                            className: "mb-8 relative title-font text-3xl lg:text-4xl xl:text-5xl font-bold tracking-tighter text-left text-gray-800 dark:text-gray-100",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                                    className: "mr-3 inline-block",
                                    children: "👋"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                                    className: "decoration-clone bg-clip-text text-transparent bg-gradient-to-b from-primary-300 to-primary-500",
                                    children: t('hey-iam-io')
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("p", {
                            className: "mb-4 md:ml-5 lg:ml-10 text-base leading-relaxed text-left text-gray-800 dark:text-gray-50 ",
                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(components_TransWithLinks, {
                                i18nText: t('hey-first-line')
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("p", {
                            className: "mb-4 md:ml-5 lg:ml-10 text-base leading-relaxed text-left text-gray-800 dark:text-gray-50",
                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(components_TransWithLinks, {
                                i18nText: t('hey-second-line')
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("p", {
                            className: "mb-4 md:ml-5 lg:ml-10 text-base leading-relaxed text-left text-gray-800 dark:text-gray-50",
                            children: t('hey-third-line')
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("p", {
                            className: "mb-8 md:ml-5 lg:ml-10 min-h-14 text-base leading-relaxed text-left text-gray-800 dark:text-gray-50",
                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(NowPlaying/* default */.Z, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                            className: "md:ml-5 lg:ml-10 flex flex-col justify-end lg:flex-row w-full",
                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(next_link["default"], {
                                href: "/about",
                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("a", {
                                    className: "cta w-full lg:w-auto px-6 py-2 mt-auto font-semibold text-center lg:text-left text-gray-50 hover:text-gray-50 bg-primary-600 hover:bg-primary-400 rounded-lg z-0 motion-safe:transition motion-safe:duration-500 motion-safe:ease-in-out motion-safe:transform focus:shadow-outline focus:outline-none focus:ring-2 ring-offset-current ring-offset-2",
                                    children: t('hey-button-cta')
                                })
                            })
                        })
                    ]
                })
            ]
        })
    }));
};
var __N_SSG = true;
/* harmony default export */ var pages = (Home);


/***/ }),

/***/ 5152:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(638)


/***/ }),

/***/ 8817:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
function regexifyString(props) {
    var pattern = props.pattern, decorator = props.decorator, input = props.input;
    var output = [];
    var matchIndex = 0;
    var processedInput = input;
    var result = pattern.exec(processedInput);
    while (result !== null) {
        var matchStartAt = result.index;
        var match = result[0];
        var contentBeforeMatch = processedInput.substring(0, matchStartAt);
        var decoratedMatch = decorator(match, matchIndex);
        output.push(contentBeforeMatch);
        output.push(decoratedMatch);
        processedInput = processedInput.substring(matchStartAt + match.length, processedInput.length + 1);
        pattern.lastIndex = 0;
        result = pattern.exec(processedInput);
        ++matchIndex;
    }
    if (processedInput) {
        output.push(processedInput);
    }
    return output;
}
exports.Z = regexifyString;


/***/ }),

/***/ 8217:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/** @license React vundefined
 * use-subscription.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var e=__webpack_require__(6086),g=__webpack_require__(1720);
exports.useSubscription=function(a){var c=a.getCurrentValue,d=a.subscribe,b=g.useState(function(){return{getCurrentValue:c,subscribe:d,value:c()}});a=b[0];var f=b[1];b=a.value;if(a.getCurrentValue!==c||a.subscribe!==d)b=c(),f({getCurrentValue:c,subscribe:d,value:b});g.useDebugValue(b);g.useEffect(function(){function b(){if(!a){var b=c();f(function(a){return a.getCurrentValue!==c||a.subscribe!==d||a.value===b?a:e({},a,{value:b})})}}var a=!1,h=d(b);b();return function(){a=!0;h()}},[c,d]);return b};


/***/ }),

/***/ 7161:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(8217);
} else {}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [22,821,477,888,179], function() { return __webpack_exec__(8581); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);